module.exports = __webpack_public_path__ + "img/3_heart.2b54d1a3.jpg";